<script type="text/javascript">
  //如更新api地址，别忘记改 store.js !!!

  //const serverPath="http://192.168.2.175:8105/";
  //const serverPath1="http://192.168.2.175:8105/";

  const serverPath="https://www.chinesemedicalvolunteers.com:8105/";
  const serverPath1="https://www.chinesemedicalvolunteers.com:8105/";
  


  export default{
      serverPath,
      serverPath1
  }
</script>



// WEBPACK FOOTER //
// src/components/global.vue